<!-- Same markup as Labour's app-spinner: a full-screen .overlay holding the Syncfusion
     spinner. [overlay]="false" drops the full-screen layer for the two in-component
     spinners (the dropdown's empty-list template and the grid row mask). -->
<div [class.overlay]="overlay" [class.inline-spinner]="!overlay">
  <div #spinnerContainer></div>
</div>
